<section class="legal">
    <h2>Aviso legal</h2>

    <div class="legal-content">
        <p>
            En cumplimiento con el deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio,
            de Servicios de la Sociedad de la Información y del Comercio Electrónico (LSSI-CE), se exponen a
            continuación los datos identificativos del titular de este sitio web:
        </p>

        <p>
            <strong>Titular:</strong> Ana Pellón Mendoza<br>
            <strong>Colegiada nº:</strong> CA01238<br>
            <strong>Domicilio:</strong> Calle Rosalia de Castro 19, 1ºB, Santander, Cantabria<br>
            <strong>Email:</strong>&nbsp;<a href="mailto:anapellonpsicologa@gmail.com">anapellonpsicologa@gmail.com</a><br>
            <strong>Teléfono:</strong>&nbsp;<a href="tel:+34675181684">+34 675 181 684</a>
        </p>

        <h3>Condiciones de uso</h3>
        <p>
            El acceso y uso de este sitio web atribuye la condición de usuario, que acepta, desde dicho acceso y uso,
            las presentes condiciones generales de uso. Las citadas condiciones serán de aplicación independientemente
            de las condiciones generales de contratación que, en su caso, resulten de obligado cumplimiento.
        </p>

        <h3>Propiedad intelectual e industrial</h3>
        <p>
            Todos los contenidos de este sitio web (textos, fotografías, gráficos, imágenes, iconos, software, diseño
            gráfico,
            código fuente, etc.) son propiedad del titular o de terceros que han autorizado su uso. El usuario se
            compromete
            a respetar los derechos de Propiedad Intelectual e Industrial.
        </p>

        <h3>Exclusión de responsabilidad</h3>
        <p>
            El titular no se hace responsable, en ningún caso, de los daños y perjuicios de cualquier naturaleza que
            pudieran ocasionar, a título enunciativo: errores u omisiones en los contenidos, falta de disponibilidad
            del portal o la transmisión de virus o programas maliciosos en los contenidos, a pesar de haber adoptado
            todas las medidas tecnológicas necesarias para evitarlo.
        </p>

        <h3>Legislación aplicable y jurisdicción</h3>
        <p>
            La relación entre el titular y el usuario se regirá por la normativa española vigente y cualquier
            controversia
            se someterá a los Juzgados y tribunales de la ciudad de Santander.
        </p>
    </div>
</section>